// extracted by mini-css-extract-plugin
module.exports = {"text":"EmptyModal_text__2mq88","offset":"EmptyModal_offset__3kbl4","modalContainer":"EmptyModal_modalContainer__3L7Br","modalHeader":"EmptyModal_modalHeader__1DdiK"};